import { useQuery } from '@tanstack/react-query';
import axios from 'plugins/api/axios';

const { teacherRecruit } = axios;

/** 取得教師合約資料 */
export const useGetTeacherRecruitment = ({
  enabled = true,
}: {
  enabled: boolean;
}) => {
  return useQuery({
    enabled,
    queryKey: ['teacherRecruitment', 'me'],
    queryFn: async () => {
      const { data, error } = await teacherRecruit.get();

      if (error || !data) {
        // 未曾簽過合約
        if (error?.errorCode === 3006) return {};

        return Promise.reject(new Error('取得教師合約資料失敗'));
      }

      return data;
    },
  });
};
